<template>
  <div class="SettingsSectionDisclaimer">
    <SettingsSectionSeparatorLine />
    <p class="SettingsSectionDisclaimer--text">
      <slot></slot>
    </p>
  </div>
</template>

<script>
import SettingsSectionSeparatorLine from "./SettingsSectionSeparatorLine.vue";
export default {
  components: {
    SettingsSectionSeparatorLine,
  },
};
</script>

<style>
.SettingsSectionDisclaimer--text {
  font-size: 14px;
  font-style: italic;
  color: #888;
  margin-top: 10px;
  line-height: 20px;
}
</style>
